// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-MForm-components-MfAttrEditor-EntityErrorsView-module__list--znaTM {
  margin: 0;
}
.src-components-MForm-components-MfAttrEditor-EntityErrorsView-module__list--znaTM li {
  margin-left: 1em;
}
/*# sourceMappingURL=EntityErrorsView.module.css.map */`, "",{"version":3,"sources":["webpack://./EntityErrorsView.module.less","webpack://./src/components/MForm/components/MfAttrEditor/EntityErrorsView.module.less"],"names":[],"mappings":"AAAA;EACE,SAAA;ACCF;ADFA;EAGI,gBAAA;ACEJ;AACA,sDAAsD","sourcesContent":[".list {\n  margin: 0;\n  li {\n    margin-left: 1em;\n  }\n}\n",".list {\n  margin: 0;\n}\n.list li {\n  margin-left: 1em;\n}\n/*# sourceMappingURL=EntityErrorsView.module.css.map */"],"sourceRoot":""}]);
// Exports
export var list = `src-components-MForm-components-MfAttrEditor-EntityErrorsView-module__list--znaTM`;
export default ___CSS_LOADER_EXPORT___;
